import { render, staticRenderFns } from "./OtherSetting.vue?vue&type=template&id=1b20c851"
import script from "./OtherSetting.vue?vue&type=script&lang=js"
export * from "./OtherSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports